import { useEffect, useRef } from 'react'

export const CONTACT_DRAFT_INTERVAL_MILI = 10000

export const timer = (onCompleted: () => void, interval: number) => {
  const timerId = setInterval(() => {
    onCompleted()
  }, interval)

  return () => {
    clearInterval(timerId)
  }
}

export const TOAST_INTERVAL_MILI = 4000

export const onceTimer = (onCompleted: () => void, interval: number) => {
  const timerId = setTimeout(() => {
    onCompleted()
  }, interval)

  return () => {
    clearTimeout(timerId)
  }
}

// Use if callback will be changed
// Reference: https://zenn.dev/kakaka/articles/41f22d2dcc9720
export const useTimer = (callback: () => void, interval: number) => {
  const callbackRef = useRef<() => void>(callback)
  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    const tick = () => {
      callbackRef.current()
    }
    const id = setInterval(tick, interval)
    return () => {
      clearInterval(id)
    }
  }, [])
}
